import jwtDecode from 'jwt-decode';
import { isFuture, fromUnixTime } from 'date-fns';

import Auth from '@/store/api/auth';
import router from '@/router';

// initial state

const token = Auth.getToken();
const jwt = token ? jwtDecode(token) : {};

const state = {
    // signin: ((Auth.getToken() !== null)),
    member: {},
    token,
    jwt
};

// getters
const getters = {
    member: state => state.member,
    isAuthenticated: state => {
        let authenticated = false;
        if (state.jwt && state.jwt.exp) authenticated = isFuture(fromUnixTime(state.jwt.exp));
        return authenticated;
    },
    token: state => state.token
};

// actions
const actions = {
    register({ commit }, member) {
        return Auth.register(member).then(({ data }) => {
            const { token, member } = data;
            commit('addTokenToState', token);
            commit('addAuthenticatedMemberToState', member);
            commit('mapRouter', null, { root: true });
        });
    },
    signin({ commit }, member) {
        return Auth.login(member).then(({ data }) => {
            const { token, member } = data;
            commit('addTokenToState', token);
            commit('addAuthenticatedMemberToState', member);
            commit('mapRouter', null, { root: true });
        });
    },
    signout({ commit }, refresh = false) {
        commit('authRemove');
        commit('mapRouter', null, { root: true });

        // TODO
        // find a better solution
        // than reloading the entire page
        if (refresh) router.go();
        // Bei UWID gehts ohne refresh

        return Auth.removeToken();
    },
    fetchAuthenticatedMember({ commit }) {
        return Auth.fetchAuthenticatedMember()
            .then(member => {
                commit('addAuthenticatedMemberToState', member);
            })
            .catch(error => {
                commit('authRemove');
                commit('mapRouter', null, { root: true });
                Auth.removeToken();
            });
    },
    sendResetLinkEmail({ commit }, payload) {
        return Auth.sendResetLinkEmail(payload);
    },
    resetPassword({ commit }, payload) {
        return Auth.resetPassword(payload).then(({ data }) => {
            // console.log(data);
        });
    },
    verifyEmail({ commit }, payload) {
        return Auth.verifyEmail(payload).then(({ data }) => {
            // console.log(data);
        });
    }
};

// mutations
const mutations = {
    addTokenToState(state, token) {
        if (token !== undefined) {
            const decodedJWT = jwtDecode(token);

            state.token = token;
            state.jwt = decodedJWT;
            // state.signin = true

            Auth.setToken(token);
        } else {
            throw 'Authetication failed: Token undefined';
        }
    },
    addAuthenticatedMemberToState(state, member) {
        if (member !== undefined) {
            state.member = member;
        } else {
            throw 'Authetication failed: Member undefined';
        }
    },
    updateMemberSettings(state, settings) {
        state.member.settings = settings;
    },
    authFail(state) {
        state.signin = false;
        Auth.removeToken();
    },
    // authReset (state) {
    // },
    // authForgot (state) {
    // },
    authRemove(state) {
        state.token = undefined;
    }
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
};
